import { CAMPAIGN_OWNER, CAMPAIGN_ADMIN, TEAM_MEMBER } from '../utils/static-configuration';

export function checkUserIsTeamMember(role) {
  if (role === CAMPAIGN_OWNER || role === CAMPAIGN_ADMIN || role === TEAM_MEMBER) {
    return true;
  } else {
    return false;
  }
}

export function checkUserHasAdminRights(role) {
  if (role === CAMPAIGN_OWNER || role === CAMPAIGN_ADMIN) {
    return true;
  } else {
    return false;
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/role-service.js
 **/